import { AUTH_SILENT_ERRORS } from '../constants';

export default function (message: string): boolean {
	return AUTH_SILENT_ERRORS.includes(message);
}
